import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { checkCodeAvailability } from './checkCodeAvailability'

interface IGetPartnerFlagSourceParams {
  profilingCodes: IProfilingCode[]
  userEmail: string
  userRoles: string[]
  partnerCountry: string
}

export const getProfilingCodeSource = ({
  profilingCodes,
  userEmail,
  userRoles,
  partnerCountry,
}: IGetPartnerFlagSourceParams) => {
  const filteredProfilingCodes = profilingCodes.filter((it) => {
    const areUsersAndRolesEmpty = !it.roles.length && !it.users.length
    return !areUsersAndRolesEmpty
  })

  const filteredCodesByCountries = filteredProfilingCodes.filter((it) => {
    if (!it.countries) {
      return true
    }

    const countries = it.countries.split(';').filter((it) => it)
    if (!countries.length) {
      return true
    }

    return countries.includes(partnerCountry)
  })

  const sortedProfilingCodeList = filteredCodesByCountries.sort((first, second) => {
    const firstAvailable = checkCodeAvailability({
      profilingCode: first,
      userEmail,
      userRoles,
    })
    const secondAvailable = checkCodeAvailability({
      profilingCode: second,
      userEmail,
      userRoles,
    })

    if (firstAvailable === secondAvailable) {
      return 0
    }

    return firstAvailable ? -1 : 1
  })

  const source = new Crud({
    fetcher: new Static(sortedProfilingCodeList),
    keyField: 'entryId',
    defaultPaging: {
      page: 0,
      pageSize: 10000,
    },
  })

  return source
}
